import React from 'react'

const DocxIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={27}
            fill="none"
            stroke="#00f"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.25}
            // className="icon icon-tabler icons-tabler-outline icon-tabler-file-type-docx"
            {...props}
        >
            <path fill="#fff" stroke="none" d="M0 0h24v24H0z" />
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4M2 15v6h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H2zM17 16.5a1.5 1.5 0 0 0-3 0v3a1.5 1.5 0 0 0 3 0M9.5 15a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-3 0v-3A1.5 1.5 0 0 1 9.5 15zM19.5 15l3 6M19.5 21l3-6" />
        </svg>
    )
}

export default DocxIcon